import React, { useState } from 'react';
import Home from './components/Home';
import Works from './components/Works';
import Experience from './components/Experience';
import About from './components/About';
import Nav from './components/Nav';

import './styles/Main.scss';
const Routes = () => {
	const [showNav, setShowNav] = useState(false);
	const navHandler = () => {
		setShowNav(!showNav);
	};

	return (
		<>
			<div className="container-fluid">
				<div className="row">
					<button onClick={navHandler} className="toggleButton">
						<i className="fas fa-bars"></i>
					</button>
					<div className={`col-md-2 ${showNav ? 'push' : ''}`}>
						<Nav />
					</div>
					<div className="holder col-md-10 col-sm-12">
						<Home />

						<About />

						<Experience />

						<Works />
					</div>
				</div>
			</div>
		</>
	);
};

export default Routes;
